import React from 'react'

type Props = {
  children: React.ReactNode
}

const Container = ({ children }: Props) => {
  return <div className="mx-auto w-full max-w-1312 px-16">{children}</div>
}

export default Container
